const HelpUrls = {
  github: "https://github.com/AudacesFoundation",
  stake: "https://stake.projectserum.com/#/",
  whitePaper: "https://arweave.net/MDXO3eeOjQdmkq_E94Ah2gTS_RuKtrm0ZvTexriOh4M",
  help: "https://docs.bonfida.org/help/",
  solana: "https://solana.com/",
  ipfs: "https://ipfs.io/",
  burn: "https://burn.bonfida.org",
};

export default HelpUrls;
